"use strict";
//
// Copyright © 2020, 2021 Anticrm Platform Contributors.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.configUserAccountUuid = exports.systemAccount = exports.systemAccountEmail = exports.readOnlyGuestAccountUuid = exports.systemAccountUuid = exports.coreId = void 0;
const component_1 = __importDefault(require("./component"));
__exportStar(require("./classes"), exports);
__exportStar(require("./client"), exports);
__exportStar(require("./collaboration"), exports);
var component_2 = require("./component");
Object.defineProperty(exports, "coreId", { enumerable: true, get: function () { return component_2.coreId; } });
Object.defineProperty(exports, "systemAccountUuid", { enumerable: true, get: function () { return component_2.systemAccountUuid; } });
Object.defineProperty(exports, "readOnlyGuestAccountUuid", { enumerable: true, get: function () { return component_2.readOnlyGuestAccountUuid; } });
Object.defineProperty(exports, "systemAccountEmail", { enumerable: true, get: function () { return component_2.systemAccountEmail; } });
Object.defineProperty(exports, "systemAccount", { enumerable: true, get: function () { return component_2.systemAccount; } });
Object.defineProperty(exports, "configUserAccountUuid", { enumerable: true, get: function () { return component_2.configUserAccountUuid; } });
__exportStar(require("./hierarchy"), exports);
__exportStar(require("@hcengineering/measurements"), exports);
__exportStar(require("./memdb"), exports);
__exportStar(require("./objvalue"), exports);
__exportStar(require("./operations"), exports);
__exportStar(require("./operator"), exports);
__exportStar(require("./query"), exports);
__exportStar(require("./storage"), exports);
__exportStar(require("./tx"), exports);
__exportStar(require("./utils"), exports);
__exportStar(require("./status"), exports);
__exportStar(require("./clone"), exports);
__exportStar(require("./common"), exports);
__exportStar(require("./time"), exports);
__exportStar(require("./benchmark"), exports);
__exportStar(require("./collaborators"), exports);
exports.default = component_1.default;
//# sourceMappingURL=index.js.map